import { rooms } from './rooms'
import {
  aiLayer,
  alerts,
  appliances,
  car,
  carExtras,
  chargers,
  climateControls,
  climateExtras,
  energy,
  household,
  houseModes,
  lightingControls,
  people,
  perDeviceEnergy,
  presence,
  security,
  sunWeather,
  system,
  systemHealth,
  weather,
} from './domains'

export * from './types'
export { rooms, floors } from './rooms'
export {
  aiLayer,
  alerts,
  appliances,
  car,
  carExtras,
  chargers,
  climateControls,
  climateExtras,
  energy,
  household,
  houseModes,
  lightingControls,
  people,
  perDeviceEnergy,
  presence,
  security,
  sunWeather,
  system,
  systemHealth,
  weather,
} from './domains'

// HA entity id: lowercase `domain.object_id`. Anything else (file paths,
// display labels, icon names) is ignored by the subscription collector.
const ENTITY_ID = /^[a-z_]+\.[a-z0-9_]+$/

function collect(obj: unknown, out: Set<string>): void {
  if (typeof obj === 'string') {
    if (ENTITY_ID.test(obj)) out.add(obj)
  } else if (Array.isArray(obj)) {
    for (const v of obj) collect(v, out)
  } else if (obj && typeof obj === 'object') {
    for (const v of Object.values(obj)) collect(v, out)
  }
}

let cached: string[] | null = null

/** The full allow-list of entity_ids the dashboard subscribes to. */
export function allEntityIds(): string[] {
  if (cached) return cached
  const set = new Set<string>()
  collect(rooms, set)
  collect(energy, set)
  collect(chargers, set)
  collect(car, set)
  collect(carExtras, set)
  collect(climateExtras, set)
  collect(climateControls, set)
  collect(lightingControls, set)
  collect(security, set)
  collect(household, set)
  collect(system, set)
  collect(systemHealth, set)
  collect(people, set)
  collect(weather, set)
  collect(sunWeather, set)
  collect(perDeviceEnergy, set)
  collect(appliances, set)
  collect(alerts, set)
  collect(presence, set)
  collect(houseModes, set)
  collect(aiLayer, set)
  cached = [...set]
  return cached
}
